import React from 'react';
import styled from 'styled-components';
import { Margin, p } from '@nib/layout';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { ConfirmationCheckbox } from '../..';
import { Field } from 'formik';
import { format } from 'date-fns';
import { formHelpTextSize, copyColor, colorDarker, copyFontFamily, formLabelColor, formLabelSize } from '@nib-components/theme';
import Link from '@nib-components/link';
import Copy from '@nib-components/copy';
import { defaultFieldPropTypes } from '../../types';
const HUMAN_SERVICES_PRIVACY_LINK = 'https://www.humanservices.gov.au/privacy';
export const defaultDeclarationLabel = `I declare that the information I have provided is true and accurate. 
I make this declaration on ${format(new Date(), 'dd/MM/yyyy')}.`;
export const DisclaimerCopy = styled.div`
  font-size: ${formHelpTextSize};
  color: ${copyColor};
`;
export const GroupFieldLabel = styled.div`
  display: block;
  color: ${formLabelColor};
  font-family: ${copyFontFamily};
  font-size: ${formLabelSize};
  font-weight: 700;
  line-height: 1.5;
`;
const DeclarationContainer = styled.div`
  border: 1px solid ${colorDarker};
  ${p(4)};
`;
export const DefaultDisclaimerCopy = () => React.createElement(React.Fragment, null, React.createElement("p", null, "Your information may be provided to the Australian Government Department of Human Services. The Department of Human Services uses this information for administering the Australian Government Rebate on private health insurance as a reduced premium. The collection of this information is permitted by the Privacy Act 1988. The Department of Human Services may disclose this information to other Commonwealth departments or agencies, anyone who you have agreed to have your information or other parties where the release is required or authorised by law (including for the purpose of research or conducting investigations)."), React.createElement("p", null, "You can get more information about the way in which the Department of Human Services will manage your personal information, including its privacy policy, at", ' ', React.createElement(Link, {
  href: HUMAN_SERVICES_PRIVACY_LINK,
  id: 'ga-inlink-human-services-privacy',
  target: "_blank"
}, "humanservices.gov.au/privacy")));
const FIELD_LABELS = {
  ARHI: DEFAULT_LABELS.DECLARATION
};
const CHECKBOX_LABELS = {
  ARHI: defaultDeclarationLabel
};
const DISCLAIMER_COPY = {
  ARHI: DefaultDisclaimerCopy()
};
const DESCRIPTIONS = {
  ARHI: DEFAULT_LABELS.DECLARATION_DESCRIPTION
};
export const Declaration = props => {
  const {
    funnel = FUNNELS.ARHI,
    label = CHECKBOX_LABELS[funnel] || CHECKBOX_LABELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    id,
    name,
    values,
    disclaimerCopy,
    fieldLabel,
    required,
    ...otherProps
  } = props;
  return React.createElement("div", null, React.createElement(Margin, {
    bottom: 4
  }, React.createElement(GroupFieldLabel, null, fieldLabel || FIELD_LABELS[funnel] || FIELD_LABELS.ARHI)), React.createElement(DeclarationContainer, null, React.createElement(Copy, {
    measure: false
  }, DESCRIPTIONS[funnel] || DESCRIPTIONS.ARHI), React.createElement(Field, {
    name: name,
    id: id,
    component: ConfirmationCheckbox,
    checked: values ? values.declaration : false,
    label: label,
    funnel: funnel,
    help: help,
    optional: optional,
    ...otherProps
  })), React.createElement(Margin, {
    top: 4
  }, React.createElement(DisclaimerCopy, null, disclaimerCopy || DISCLAIMER_COPY[funnel] || DISCLAIMER_COPY.ARHI)));
};
Declaration.defaultProps = {
  ...defaultFieldPropTypes
};
const DeclarationWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(Declaration, {
  ...props
}));
export default DeclarationWithFunnel;